import React from "react";

export const CardInfoIcon = () => {
  return (
    <>
      <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 13.0005H8.01126M13.0056 13.0005H13.0169M17.9887 13.0005H18" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M13 25.5C19.9036 25.5 25.5 19.9036 25.5 13C25.5 6.09644 19.9036 0.5 13 0.5C6.09644 0.5 0.5 6.09644 0.5 13C0.5 19.9036 6.09644 25.5 13 25.5Z" stroke="white"/>
      </svg>
    </>
  );
};
